const formateHeader = (headerRows) => {
    const header = [];
    const keys = Object.keys(headerRows);
    keys.forEach((key)=>{
      let obj = {};
      obj["key"] = key;
      obj["label"] = headerRows[key];
      header.push(obj);
    });
    return header;
  }
const formateRows = (rowsData) => {
    const formatedRows = [];
    rowsData.forEach((row)=>{
      let rowObj= {};
      const keys = Object.keys(row);
      keys.forEach((key)=>{
        rowObj[key] = row[key];
      });
      formatedRows.push(rowObj);
    });
    return formatedRows;
  }

export { formateHeader, formateRows, };



// WEBPACK FOOTER //
// ./src/utils/csvUtils.js